// This is a modal for Dashboardenterpriseone

import { Button as AIMEButton } from "tot-loft-component-library";

import styled from "@emotion/styled";

export default function ModalDashboardenterpriseone({ onClose }) {
  return (
    <RootWrapperModalDashboardenterpriseone>
      <Overlay>
        <Wrapper>
          <Frame1392>
            <IconFilled
              src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/f0398cd1-f246-4a2f-bf82-cc1a51778300"
              alt="icon"
            />
          </Frame1392>
          <PopupMessages>
            <Left>
              <Frame1391>
                <BirthdayParty2 />
                <Congratulations>Congratulations!</Congratulations>
                <AReferralYouMadeToVendorNameWasSuccessfulAndYouVeEarnedAFixedReferralRewardOfReward>
                  A referral you made to [vendor name] was successful, and
                  you’ve earned a Fixed Referral Reward of [Reward].
                </AReferralYouMadeToVendorNameWasSuccessfulAndYouVeEarnedAFixedReferralRewardOfReward>
                <KeepHelpingYourFriendsToEarnMoreRewards>
                  Keep helping your friends to earn more rewards!
                </KeepHelpingYourFriendsToEarnMoreRewards>
                <Frame1400>
                  <AIMEButton
                    size="small"
                    onClick={() => alert("View Details clicked")}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      width: "251px",
                      background: "rgb(33, 37, 67)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      View Details
                    </span>
                  </AIMEButton>
                </Frame1400>
              </Frame1391>
            </Left>
          </PopupMessages>
        </Wrapper>
      </Overlay>
    </RootWrapperModalDashboardenterpriseone>
  );
}

const RootWrapperModalDashboardenterpriseone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;

const Frame1392 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  height: 1px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const IconFilled = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const PopupMessages = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 912px;
  box-sizing: border-box;
  padding: 24px 0px;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const BirthdayParty2 = styled.div`
  width: 174px;
  height: 174px;
  background: url(https://s3-alpha-sig.figma.com/img/59b4/0d96/0cc75826bab07fb884e643c34b30416c?Expires=1749427200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=PcARQkkXB41fYZYyF7yFgZY9kKEBgLkCevX8FwZ9l16gogsVcBptFdpz3acM3tZh3m0bYF6bgQQYZuwgJk21x23boEm188M6Q~RyBZY8igHAojpoVEnXJN02CX1gc2RKrTYxw~3KPiAoc4sRaeZzfWp0g1q0CGu3Ms4VxY6mJsRI8DgKnPqLKs6MLREAjywzymEvHAkO~o~XA1tVL9PrKE3tFB-A4vY1EqLcJxerR-m7eZ2moo~8jDbuEAxWLRlIv8lA1ZiEO9b1YAXX5VDd5-Sbt6Nqva4T72JwONELDFKGex-GBFqeHF48S7H84vqbNUGvDuzaGaIuPvNBdyUgGA__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const Congratulations = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const AReferralYouMadeToVendorNameWasSuccessfulAndYouVeEarnedAFixedReferralRewardOfReward = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const KeepHelpingYourFriendsToEarnMoreRewards = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1400 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
`;
